import React from "react";
import {
    Shield,
    Mail,
    Phone,
    Lock,
    Smartphone,
    Monitor,
    Trash2,
    ChevronRight
} from "lucide-react";

import "./DeliveryPrivacy.css";

function DeliveryPrivacy() {

    const securityItems = [

        {
            icon: <Mail size={22} />,
            title: "Email Verification",
            subtitle: "Your email is verified",
            status: "Verified"
        },

        {
            icon: <Phone size={22} />,
            title: "Mobile Verification",
            subtitle: "Your mobile number is verified",
            status: "Verified"
        },

        {
            icon: <Lock size={22} />,
            title: "Password",
            subtitle: "Password is protected",
            status: "Secure"
        },

        {
            icon: <Smartphone size={22} />,
            title: "Two-Factor Authentication",
            subtitle: "Coming Soon",
            status: "Coming Soon"
        },

        {
            icon: <Monitor size={22} />,
            title: "Active Devices",
            subtitle: "Current logged in device",
            status: "1 Device"
        }

    ];

    return (

        <div className="delivery-privacy-page">

            <div className="privacy-header">

                <h1>

                    Privacy & Security

                </h1>

                <p>

                    Protect your HomeFoods account.

                </p>

            </div>

            <div className="privacy-card">

                {

                    securityItems.map((item, index) => (

                        <div
                            key={index}
                            className="privacy-item"
                        >

                            <div className="privacy-left">

                                <div className="privacy-icon">

                                    {item.icon}

                                </div>

                                <div>

                                    <h3>

                                        {item.title}

                                    </h3>

                                    <p>

                                        {item.subtitle}

                                    </p>

                                </div>

                            </div>

                            <div className="privacy-right">

                                <span>

                                    {item.status}

                                </span>

                                <ChevronRight size={18} />

                            </div>

                        </div>

                    ))

                }

            </div>

            <div className="danger-zone">

                <div className="danger-header">

                    <Shield size={24} />

                    <h2>

                        Danger Zone

                    </h2>

                </div>

                <p>

                    Deleting your account is permanent.
                    This action cannot be undone.

                </p>

                <button
                    className="delete-account-btn"
                    onClick={() =>
                        alert(
                            "Delete Account feature will be available soon."
                        )
                    }
                >

                    <Trash2 size={18} />

                    Delete Account

                </button>

            </div>

        </div>

    );

}

export default DeliveryPrivacy;